export default "//cdn.scentbird.com/assets/frontbird-site/images/visa-mastercard@2x_0e3a1d.png";